module.exports = __webpack_public_path__ + "assets/img/best-in-test-logo.19201141.png";